import { UserOverviewDTO } from 'entities/userOverview';
import { DataType } from './UserTable.types';

export const mapDataToTableColumns = (mappedData: UserOverviewDTO[]): DataType[] => {
  return mappedData?.map(({ id, firstName, lastName, picture, ...user }) => ({
    ...user,
    name: { id, firstName, lastName, picture },
  }));
};
